import { EmailConfigActionTypes } from './enums';
import { type EmailConfigAction, type IEmailConfigState } from './interfaces';

export const initialState: IEmailConfigState = {
	isFetchingAll: false,
	configs: [],
	totalRecords: 0,
	fetchAllError: null,

	isFetchingDetail: false,
	configDetail: null,
	fetchDetailError: null,

	isUpdating: false,
	updateError: null,

	emailSuggestions: [],
	isFetchingEmailSuggestions: false
};

export default (state = initialState, { type, payload }: EmailConfigAction): IEmailConfigState => {
	switch (type) {
		case EmailConfigActionTypes.FETCH_ALL_EMAIL_CC_CONFIG_REQUEST:
			return {
				...state,
				isFetchingAll: true,
				fetchAllError: null
			};
		case EmailConfigActionTypes.FETCH_ALL_EMAIL_CC_CONFIG_SUCCESS:
			return {
				...state,
				isFetchingAll: false,
				configs: payload?.configs || [],
				totalRecords: payload?.totalRecords ?? 0
			};
		case EmailConfigActionTypes.FETCH_ALL_EMAIL_CC_CONFIG_FAILURE:
			return {
				...state,
				isFetchingAll: false,
				fetchAllError: payload
			};

		case EmailConfigActionTypes.GET_EMAIL_CC_CONFIG_BY_NAME_REQUEST:
			return {
				...state,
				isFetchingDetail: true,
				configDetail: null,
				fetchDetailError: null
			};
		case EmailConfigActionTypes.GET_EMAIL_CC_CONFIG_BY_NAME_SUCCESS:
			return {
				...state,
				isFetchingDetail: false,
				configDetail: payload
			};
		case EmailConfigActionTypes.GET_EMAIL_CC_CONFIG_BY_NAME_FAILURE:
			return {
				...state,
				isFetchingDetail: false,
				fetchDetailError: payload
			};

		case EmailConfigActionTypes.UPSERT_EMAIL_CC_CONFIG_REQUEST:
			return {
				...state,
				isUpdating: true,
				updateError: null
			};
		case EmailConfigActionTypes.UPSERT_EMAIL_CC_CONFIG_SUCCESS:
			return {
				...state,
				isUpdating: false,
				configDetail: payload,
				configs: state.configs.map(config =>
					config.name === payload?.name ? { ...config, ...payload } : config
				)
			};
		case EmailConfigActionTypes.UPSERT_EMAIL_CC_CONFIG_FAILURE:
			return {
				...state,
				isUpdating: false,
				updateError: payload
			};

		case EmailConfigActionTypes.FETCH_EMAIL_AUTOCOMPLETE_REQUEST:
			return {
				...state,
				isFetchingEmailSuggestions: true
			};
		case EmailConfigActionTypes.FETCH_EMAIL_AUTOCOMPLETE_SUCCESS:
			return {
				...state,
				isFetchingEmailSuggestions: false,
				emailSuggestions: payload?.emails || []
			};
		case EmailConfigActionTypes.FETCH_EMAIL_AUTOCOMPLETE_FAILURE:
			return {
				...state,
				isFetchingEmailSuggestions: false,
				emailSuggestions: []
			};

		case EmailConfigActionTypes.CLEAR_EMAIL_SUGGESTIONS:
			return {
				...state,
				emailSuggestions: []
			};

		case EmailConfigActionTypes.RESET_EMAIL_CONFIG_DETAIL:
			return {
				...state,
				configDetail: null,
				fetchDetailError: null,
				emailSuggestions: []
			};

		default:
			return state;
	}
};
